import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { IconButton } from '@mui/material';
import React from 'react';

interface SortableItemContextType {
  attributes: Record<string, unknown>;
  listeners: Record<string, unknown> | undefined;
  isDragging: boolean;
}

export const SortableItemContext = React.createContext<SortableItemContextType>({
  attributes: {},
  listeners: {},
  isDragging: false,
});

export const SortableSectionItem = ({
  id,
  children,
}: {
  id: string;
  children: React.ReactNode;
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.3 : 1,
    position: 'relative' as const,
    zIndex: isDragging ? 999 : 'auto',
  };

  return (
    <SortableItemContext.Provider
      value={{
        attributes: attributes as unknown as Record<string, unknown>,
        listeners: listeners as unknown as Record<string, unknown>,
        isDragging,
      }}
    >
      <div ref={setNodeRef} style={style} id={`section-${id}`}>
        {children}
      </div>
    </SortableItemContext.Provider>
  );
};

export const SectionDragHandle = () => {
  const { attributes, listeners } = React.useContext(SortableItemContext);
  return (
    <IconButton
      size="small"
      {...attributes}
      {...listeners}
      sx={{ cursor: 'grab', mr: 1 }}
      className="drag-handle"
      onClick={(e) => e.stopPropagation()}
    >
      <DragIndicatorIcon fontSize="small" color="disabled" />
    </IconButton>
  );
};
